import { render } from "./CreateTaskType.vue?vue&type=template&id=73b99a5e"
import script from "./CreateTaskType.vue?vue&type=script&lang=js"
export * from "./CreateTaskType.vue?vue&type=script&lang=js"

import "./CreateTaskType.vue?vue&type=style&index=0&id=73b99a5e&lang=css"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__